// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__1YM_c"};